<script lang="ts">
  let {
    value,
    singular = 'item',
    plural = 'items',
  }: {
    value: unknown
    singular?: string
    plural?: string
  } = $props()

  const count = $derived(Number(value))
  const displayCount = $derived(Number.isFinite(count) ? count : String(value ?? ''))
  const label = $derived(count === 1 ? singular : plural)
</script>

<span class="widget-count-chip">{displayCount} {label}</span>
